import { motion } from 'framer-motion';
import React from 'react';
import { scaleVariants, shouldReduceMotion } from 'src/tef/components/config/animationConfig';
import { ComponentVariant } from 'src/tef/components/utils/types';

interface ScaleAnimationProps {
  children: React.ReactNode;
  variant?: ComponentVariant & { duration?: 'fast' | 'normal' | 'slow'; delay?: number };
  className?: string;
}

export const ScaleAnimation: React.FC<ScaleAnimationProps> = ({ children, variant = {}, className }) => {
  const duration = variant.duration || 'normal';
  const delay = variant.delay || 0;
  const reduceMotion = shouldReduceMotion();

  const animationVariants = reduceMotion
    ? {
        hidden: { opacity: 1, scale: 1 },
        visible: { opacity: 1, scale: 1 },
        exit: { opacity: 1, scale: 1 },
      }
    : {
        hidden: scaleVariants.hidden,
        visible: {
          opacity: 1,
          scale: 1,
          transition: {
            duration: duration === 'fast' ? 0.2 : duration === 'slow' ? 0.5 : 0.3,
            delay,
            ease: [0.4, 0, 0.2, 1],
          },
        },
        exit: scaleVariants.exit,
      };

  return (
    <motion.div initial="hidden" animate="visible" exit="exit" variants={animationVariants} className={className}>
      {children}
    </motion.div>
  );
};

ScaleAnimation.displayName = 'ScaleAnimation';
